import { Button } from "@repo/ui/components/button";
import { useForm } from "@repo/ui/hooks/use-form";
import { Keyboard } from "../../../components/keyboard";
import { urlLoadProduct } from "../../../urls";
import { useLocation, useNavigate } from "react-router";
import { Title } from "../../../components/title";

function Price() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { ref, values, handleChangeValue } = useForm({
    initialValues: {
      price: "",
    },
    onSubmit: () => {
      navigate(urlLoadProduct("sku"), {
        state: { ...state, price: values.price },
      });
    },
  });
  return (
    <form ref={ref} className="flex flex-col items-center gap-4 w-full py-4">
      <Title>¿Cuál es el precio del producto?</Title>
      <div
        className={`w-full bg-white border border-gray-200 rounded-md flex items-center justify-center h-12 pt-1 ${
          values.price === "" ? "text-gray-400" : ""
        }`}
      >
        {values.price}
      </div>
      <Keyboard
        onChange={(value) => handleChangeValue("price", value)}
        value={values.price}
        type="numbers"
      />
      <Button
        type="submit"
        size="4xl"
        variant="pos"
        className="w-full"
        disabled={values.price.length < 1}
      >
        Continuar
      </Button>
    </form>
  );
}

export const route = {
  path: urlLoadProduct("price"),
  element: <Price />,
};
